import { CreateItemReviewForm, type CreateItemReviewFormProps } from '@/components/item-review/CreateItemReviewForm';

const ItemReviewTab = ({
    primaryKey,
    item,
    onReviewChange,
    onToggleReview,
}: {
    primaryKey: string;
    item?: CreateItemReviewFormProps['item'];
    onReviewChange?: (isDirty: boolean) => void;
    onToggleReview?: () => void;
}) => {
    return (
        <div className="tw-absolute tw-bottom-20 tw-z-50 tw-max-h-[70vh] tw-w-full tw-overflow-y-auto tw-bg-[#f6f6f6] tw-px-4 tw-pb-6 tw-pt-2">
            <CreateItemReviewForm
                primaryKey={primaryKey}
                item={item}
                onDirtyChange={onReviewChange}
                onSent={onToggleReview}
            />
        </div>
    );
};

export { ItemReviewTab };
